import { useEffect, useRef } from 'react';

// Covers switching tabs, returning from an external app, and browser back/forward cache.
export function useRefreshOnReturn(refresh: () => Promise<unknown> | void) {
  const callback = useRef(refresh);
  callback.current = refresh;
  useEffect(() => {
    let running = false;
    const resume = () => {
      if (document.visibilityState === 'hidden' || running) return;
      running = true;
      void Promise.resolve().then(() => callback.current()).catch(() => {}).finally(() => { running = false; });
    };
    const pageShow = (event: PageTransitionEvent) => { if (event.persisted) resume(); };
    window.addEventListener('focus', resume);
    window.addEventListener('pageshow', pageShow);
    document.addEventListener('visibilitychange', resume);
    return () => {
      window.removeEventListener('focus', resume);
      window.removeEventListener('pageshow', pageShow);
      document.removeEventListener('visibilitychange', resume);
    };
  }, []);
}
